import { render } from "./nodata.vue?vue&type=template&id=92cb4cb4&scoped=true"
import script from "./nodata.vue?vue&type=script&lang=js"
export * from "./nodata.vue?vue&type=script&lang=js"

import "./nodata.vue?vue&type=style&index=0&id=92cb4cb4&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92cb4cb4"]])

export default __exports__